import AsyncButton from "@/components/AsyncButton";
import { Trash2, UserPlus } from "lucide-react";
import { useTranslation } from "react-i18next";

interface EmailTypeAllowedRolesTableActionsProps {
  variant: "outline" | "secondary";
  selectedCount: number;
  isSubmitting: boolean;
  onRemoveSelected: () => void;
  onOpenAddRoles: () => void;
  testIds?: {
    removeSelected?: string;
    addRoles?: string;
  };
}

export const EmailTypeAllowedRolesTableActions = ({
  variant,
  selectedCount,
  isSubmitting,
  onRemoveSelected,
  onOpenAddRoles,
  testIds,
}: EmailTypeAllowedRolesTableActionsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <AsyncButton
        type="button"
        variant={variant}
        size="sm"
        className="gap-2"
        disabled={selectedCount === 0 || isSubmitting}
        onClick={onRemoveSelected}
        label={`${t("emailTypes.roles.removeSelected")}${selectedCount > 0 ? ` (${selectedCount})` : ""}`}
        loading={isSubmitting}
        icon={<Trash2 className="h-5 w-5 shrink-0" />}
        data-testid={testIds?.removeSelected}
      />
      <AsyncButton
        type="button"
        variant={variant}
        size="sm"
        className="gap-2"
        disabled={isSubmitting}
        onClick={onOpenAddRoles}
        label={t("emailTypes.roles.addButton")}
        loading={isSubmitting}
        icon={<UserPlus className="h-5 w-5 shrink-0" />}
        data-testid={testIds?.addRoles}
      />
    </>
  );
};
